import Check from '@/assets/icons/check.svg?react';
import XClose from '@/assets/icons/x-close.svg?react';
import Dot from '@/assets/icons/dot.svg?react';

export const surveyStatusText = {
  sent: 'Sent',
  "didn't sent": "Didn't sent",
  received: 'Received',
};

export const surveyStatusIcon = {
  sent: Check,
  "didn't sent": XClose,
  received: Dot,
};
